// @ts-nocheck
import usePrevious from "@insite/client-framework/Common/Hooks/usePrevious";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { useSettingsCollection } from "@store/Framework/Store/Context/ContextHooks";
import { useEffect } from "react";

const useProductInfosCallback = (
    productInfos: ProductInfo[],
    callback: () => any,
    canCallback = true,
    skipPricing = false,
) => {
    const canSeePrices = useSettingsCollection().productSettings.canSeePrices;
    const previousProductInfos = usePrevious(productInfos);

    const allowCallback =
        canCallback &&
        Boolean(productInfos?.length) &&
        (canSeePrices
            ? !skipPricing
                ? productInfos.every(x => x.pricing && x.inventory)
                : productInfos.every(x => x.inventory)
            : previousProductInfos?.[0]?.productId !== productInfos?.[0]?.productId);

    useEffect(() => {
        if (allowCallback) {
            callback();
        }
    }, [allowCallback]);
};

export default useProductInfosCallback;
